import { Link, type LinkProps, Outlet, useLocation } from '@tanstack/react-router'

import { Separator } from '@/components/separator/separator'
import { Tabs, TabsList, TabsTrigger } from '@/components/tabs/tabs'

import { cn } from '@/lib/utils'

import { DASHBOARD_TABS } from './constants'
import { useCaseActionHistoryDrawerStore } from './store'
import { CaseRecentActivityDrawer } from './ui/case-recent-activity-drawer/case-recent-activity-drawer'

const DASHBOARD_PAGE_PATHS: LinkProps['to'][] = [
  '/dashboard/task-management',
  '/dashboard/case-updates',
  '/dashboard/case-analysis',
  '/dashboard/general-info',
]

export const DashboardLayout = () => {
  const { pathname } = useLocation()
  const {
    taskId,
    isOpen: isOpenCaseHistoryDrawer,
    close: closeCaseActionHistoryDrawer,
  } = useCaseActionHistoryDrawerStore()

  const currentDashboardPagePath = DASHBOARD_PAGE_PATHS.filter((pagePath) => pathname.includes(pagePath ?? ''))[0]

  return (
    <div className={cn('relative', 'h-fit', 'px-10 pb-28 pt-11')}>
      <div className={cn('text-2xl font-bold')}>Dashboard</div>

      <Separator className={cn('my-6')} />

      <Tabs value={currentDashboardPagePath} className={cn('mt-6')}>
        <TabsList>
          {DASHBOARD_TABS.map(({ label, value, to }) => (
            <Link key={value} to={to}>
              <TabsTrigger value={to ?? ''}>{label}</TabsTrigger>
            </Link>
          ))}
        </TabsList>
      </Tabs>

      <div className={cn('my-5')}>
        <Outlet />
      </div>

      {taskId && (
        <CaseRecentActivityDrawer
          open={isOpenCaseHistoryDrawer}
          taskId={taskId}
          onClickCloseButton={closeCaseActionHistoryDrawer}
        />
      )}
    </div>
  )
}
